import React, { useEffect } from 'react'
import styles from './MerchantPc.module.scss'
import Header from './components/Header'
import HeroSection from './components/HeroSection'
import ValueSection from './components/ValueSection'
import TestimonialSection from './components/TestimonialSection'
import CaseStudySection from './components/CaseStudySection'
import Footer from './components/Footer'
import { getLocaleStyleClass } from '@/utils/i18n'
import { isProd } from '@/utils/utils'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { useDeviceType } from '@/common/hoc/getDeviceType'

const MerchantPc: React.FC<WithI18nProps> = (props) => {
  const { i18n } = props
  const deviceType = useDeviceType()
  useEffect(() => {
   if (deviceType === 'mobile') {
     window.location.href = isProd() ? 'https://osm.dianping.com/os/h5/seek-investment/merchantH5.html' : 'https://osm.51ping.com/os/h5/seek-investment/merchantH5.html', '_blank'
   }
  }, [deviceType])

  const openJoin = () => {
    // 跳转到新页面
    window.location.href = isProd() ? 'https://osm.dianping.com/os/h5/seek-investment/merchantJoin.html' : 'https://osm.51ping.com/os/h5/seek-investment/merchantJoin.html'
  }

  // 把页面标签名 改为Meituan Merchant
  useEffect(() => {
    document.title = 'Meituan Merchant'
  }, [])
  const getCurrentLanguage = () => {
    if (!i18n) return 'zh-CN';
    return i18n.getLocale() || 'zh-CN';
  };

  const getCurrentLanguageClass = (style: string): string => {
    return getLocaleStyleClass(getCurrentLanguage(), style)
  }

  return (
    <div className={`${styles.pcContainer } ${styles[getCurrentLanguageClass('pcContainer')]}`}>
      <Header onJoin={openJoin} />
      <main>
        <HeroSection onJoin={openJoin} />
        <ValueSection />
        {/* <MarketingSection /> */}
        <TestimonialSection  />
        <CaseStudySection onJoin={openJoin} />
      </main>
      <Footer />
    </div>
  )
}

export default withTranslator(MerchantPc)